import { InstanciaService } from '@app/services/instancia.service';
import { NgModule, LOCALE_ID, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, ErrorHandler } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { HeaderInterceptor } from './services/autorizacao.interceptor';
// import { BrowserModule } from '@angular/platform-browser';
// import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ReactiveFormsModule } from '@angular/forms';
import { CurrencyPipe, registerLocaleData } from '@angular/common';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ScrollingModule } from '@angular/cdk/scrolling';
import ptBr from '@angular/common/locales/pt';
registerLocaleData(ptBr);
import { AppRoutingModule } from '@app/app.routing';
// GUARDS
// import { AuthGuard } from '@app/guards/auth.guard';
// COMPONENTES
import { AppComponent } from '@app/app.component';
// import { AsideToggleDirective } from '@app/directives/aside.directive';
import { SIDEBAR_TOGGLE_DIRECTIVES } from '@app/directives/sidebar.directive';
import { NAV_DROPDOWN_DIRECTIVES } from '@app/directives/nav-dropdown.directive';
import { LayoutComponent } from '@app/components/layout/layout.component';
import { LayoutAsideMenuComponent } from './components/layout/layout-aside-menu/layout-aside-menu.component';
import { AutoFocusDirective } from './directives/Autofocus';
import { LayoutModule } from '@angular/cdk/layout';
// PAGINAS
import { LoginComponent } from '@app/pages/home/login/login.component';
import { DashboardComponent } from '@app/pages/home/dashboard/dashboard.component';
import { AlterarSenhaComponent } from './pages/home/alterar-senha/alterar-senha.component';
import { MeAviseTransferenciaComponent } from './pages/home/me-avise-transferencia/me-avise-transferencia.component';
// Módulos Cardeal
import { AgendaModule } from './pages/agenda/agenda.module';
import { CadastrosModule } from './pages/cadastros/cadastros.module';
import { ProcessosModule } from './pages/processos/processos.module';
import { PeticaoModule } from './pages/peticao/peticao.module';
import { RelatoriosModule } from '@app/pages/relatorios/relatorios.module';
import { FinanceiroModule } from './pages/financeiro/financeiro.module';
import { ConfiguracoesModule } from '@app/pages/configuracoes/configuracoes.module';
import { SharedModule } from './shared/shared.module';
import { AdministrativoClientesModule } from './pages/administrativo-clientes/administrativo-clientes.module';
import { NgSelectModule } from '@ng-select/ng-select';

import { LoginService } from '@app/services/login.service';
import { ReciboService } from '@app/services/recibo.service';
import { ReciboMultiploService } from './services/recibo-multiplo.service';
import { UtilitarioService } from '@app/services/utilitario.service';
import { HomeService } from '@app/services/home.service';
import { ReceberService } from '@app/services/receber.service';
import { PagarService } from '@app/services/pagar.service';
import { FormaDePagamentoService } from '@app/services/forma-de-pagamento.service';
import { LancamentoService } from '@app/services/lancamento.service';
import { MovimentacaoService } from '@app/services/movimentacao.service';
import { ConsultasService } from '@app/services/consultas.service';
import { CidadeService } from '@app/services/cidade.service';
import { BancoService } from '@app/services/banco.service';
import { ContaService } from '@app/services/conta.service';
import { MovimentacaoAvisoService } from '@app/services/movimentacao-aviso.service';
import { UnidadeService } from '@app/services/unidade.service';
import { UsuarioTipoService } from '@app/services/usuario-tipo.service';
import { DocumentoService } from '@app/services/documento.service';
import { NaturezaDeAcaoService } from '@app/services/natureza-de-acao.service';
import { OrgaoDoJudiciarioService } from '@app/services/orgao-do-juriciario.service';
import { PedidoService } from '@app/services/pedido.service';
import { PosicaoDoClienteService } from '@app/services/posicao-do-cliente.service';
import { RitoService } from '@app/services/rito.service';
import { TipoDeAcaoService } from '@app/services/tipo-de-acao.service';
import { TipoDeJulgamentoService } from '@app/services/tipo-de-julgamento.service';
import { DemonstrativoDeResultadoService } from '@app/services/demonstrativo-de-resultado.service';
import { RelatorioService } from '@app/services/relatorio.service';
import { ChequeService } from './services/cheque.service';
import { UsuarioService } from './services/usuario.service';
import { AzureStorageService } from './services/azure-storage.service';

// MÓDULOS TERCEIROS
import { NgxSelectModule, INgxSelectOptions } from 'ngx-select-ex';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { TextMaskModule } from 'angular2-text-mask';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';

import { ToastrModule } from 'ngx-toastr';
import { CalendarHeaderComponent } from './utils/calendar-header.component';
// import { DateTimePickerComponent } from './utils/date-time-picker.component';
import { CurrencyMaskModule, CurrencyMaskConfig, CURRENCY_MASK_CONFIG } from 'ng2-currency-mask';
import { ClipboardModule } from 'ngx-clipboard';
import { ErroHandlerService } from './services/insights/erro-handler.service';
import { MonitoramentoService } from './services/insights/monitoramento.service';
import { NotaFiscalService } from './services/nota-fiscal.service';
import { environment } from 'environments/environment';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { RecuperarSenhaComponent } from './pages/home/recuperar-senha/recuperar-senha.component';
import { RedefinirSenhaComponent } from './pages/home/redefinir-senha/redefinir-senha.component';
import { AutenticacaoDoisFatoresComponent } from './pages/home/autenticacao-dois-fatores/autenticacao-dois-fatores.component';

// CONFIGURAÇÕES MÓDULOS
export const CustomCurrencyMaskConfig: CurrencyMaskConfig = {
  align: 'left',
  allowNegative: false,
  decimal: ',',
  precision: 2,
  prefix: 'R$ ',
  suffix: '',
  thousands: '.'
};
const CustomSelectOptions: INgxSelectOptions = {
  optionValueField: 'Id',
  optionTextField: 'Descricao',
  placeholder: 'Pesquisar...',
  allowClear: true,
  keepSelectedItems: true,
  noResultsFound: 'Nenhum resultado encontrado'
};
@NgModule({
  declarations: [
    AppComponent,
    LayoutComponent,
    LayoutAsideMenuComponent,
    NAV_DROPDOWN_DIRECTIVES,
    SIDEBAR_TOGGLE_DIRECTIVES,
    // AsideToggleDirective,
    AutoFocusDirective,
    // PÁGINAS
    LoginComponent,
    DashboardComponent,
    AlterarSenhaComponent,
    MeAviseTransferenciaComponent,
    // MÓDULOS
    CalendarHeaderComponent,
    RecuperarSenhaComponent,
    RedefinirSenhaComponent,
    AutenticacaoDoisFatoresComponent
    // DateTimePickerComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    SharedModule,
    ScrollingModule,
    DragDropModule,
    LayoutModule,
    ToastrModule.forRoot({
      timeOut: 7000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
    }),
    NgSelectModule,
    SharedModule,
    ReactiveFormsModule,
    HttpClientModule,
    AppRoutingModule,
    BsDropdownModule.forRoot(),
    TabsModule.forRoot(),
    PaginationModule.forRoot(),
    TooltipModule.forRoot(),
    ButtonsModule.forRoot(),
    ModalModule.forRoot(),
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory
    }),
    // Ng2CompleterModule,
    TextMaskModule,
    CurrencyMaskModule,
    ClipboardModule,
    NgxSelectModule.forRoot(CustomSelectOptions),
    // Sistema modularizado
    AgendaModule,
    CadastrosModule,
    ProcessosModule,
    PeticaoModule,
    RelatoriosModule,
    FinanceiroModule,
    ConfiguracoesModule,
    // PAINEL ADMINISTRATIVO SISTEMA CLIENTES
    environment.CARDEAL_EDICAO === 'CLIENTE' ? AdministrativoClientesModule : []
  ],
  providers: [
    // AuthGuard,
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    { provide: HTTP_INTERCEPTORS, useClass: HeaderInterceptor, multi: true },
    { provide: CURRENCY_MASK_CONFIG, useValue: CustomCurrencyMaskConfig },
    { provide: ErrorHandler, useClass: ErroHandlerService },
    // SERVICES
    BancoService,
    CidadeService,
    ConsultasService,
    ContaService,
    ChequeService,
    DemonstrativoDeResultadoService,
    DocumentoService,
    FormaDePagamentoService,
    HomeService,
    LancamentoService,
    LoginService,
    MovimentacaoAvisoService,
    MovimentacaoService,
    MonitoramentoService,
    NaturezaDeAcaoService,
    InstanciaService,
    OrgaoDoJudiciarioService,
    PagarService,
    PedidoService,
    PosicaoDoClienteService,
    ReceberService,
    ReciboService,
    ReciboMultiploService,
    RelatorioService,
    RitoService,
    TipoDeAcaoService,
    TipoDeJulgamentoService,
    UnidadeService,
    UsuarioTipoService,
    UtilitarioService,
    UsuarioService,
    NotaFiscalService,
    AzureStorageService,
    // pipes
    CurrencyPipe
  ],
  bootstrap: [AppComponent],
  exports: [
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class AppModule { }
